module.exports = __webpack_public_path__ + "static/Kichul_Kang_Resume-c399f4103e402c90855801341b7e9812.pdf";